import { Immutable } from "immer";
import React from "react";

import type { StearnsAnchorBlock as Value } from "@reactivated";

type Props = Immutable<{
    value: Value;
}>;

export const StearnsAnchorBlock = (props: Props): React.JSX.Element => {
    return <div id={props.value.id_text ?? undefined} />;
};
